import Reveal from "@/components/base/Reveal";
import { versionPillars, stats } from "@/mocks/home";

export default function VersionOverview() {
  return (
    <section id="overview" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <Reveal>
          <div className="max-w-2xl">
            <p className="font-label text-xs font-semibold uppercase tracking-[0.25em] text-primary-600">
              Version Overview
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              四种常见的版本与标注方式
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              围绕《嫂子的诱惑》的字幕与语言信息，实际会遇到的版本大致可以分为四类。先了解它们的区别，
              再结合自己的观看习惯选择，通常比逐条比对更高效。
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {versionPillars.map((item, index) => (
            <Reveal key={item.title} delay={index * 90}>
              <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                  <i className={`${item.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-1 font-label text-xs text-secondary-600">{item.subtitle}</p>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                <ul className="mt-4 space-y-1.5 border-t border-background-200 pt-4">
                  {item.points.map((point) => (
                    <li key={point} className="flex items-start gap-2 text-xs text-foreground-700">
                      <i className="ri-checkbox-circle-line mt-0.5 text-accent-600" aria-hidden="true"></i>
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <dl className="mt-12 grid grid-cols-2 gap-4 rounded-lg border border-background-200 bg-secondary-100/70 p-6 lg:grid-cols-4">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <dt className="sr-only">{stat.label}</dt>
                <dd>
                  <span className="block font-heading text-3xl font-bold text-primary-700 md:text-4xl">
                    {stat.value}
                  </span>
                  <span className="mt-2 block font-label text-xs text-foreground-600 md:text-sm">{stat.label}</span>
                </dd>
              </div>
            ))}
          </dl>
        </Reveal>
      </div>
    </section>
  );
}